import * as React from 'react';
import { TrafficAllocationInput } from '@app/react-common/components/traffic-allocation/TrafficAllocationInput';
import { TrafficAllocationVariant } from '@app/react-common/components/traffic-allocation/TrafficAllocationShared';
import { AbTestFormData } from '../AbTestModal';
import { Shop } from '@pdqdev/pdq-shared/dist/entities/Shop';

interface ShippingMethodsAllocationSectionProps {
  formData: AbTestFormData;
  setFormData: React.Dispatch<React.SetStateAction<AbTestFormData>>;
  setTrafficAllocationValid: (valid: boolean) => void;
  mode: string;
  shop: Shop;
}

export const ShippingMethodsAllocationSection: React.FC<ShippingMethodsAllocationSectionProps> = ({
  formData,
  setFormData,
  setTrafficAllocationValid,
  mode,
  shop,
}) => {
  return (
    <TrafficAllocationInput
      trafficAllocationConfig={{
        variants: formData?.abTestVariants,
      }}
      shop={shop}
      onChange={(valid: boolean, variants: TrafficAllocationVariant[]) => {
        setTrafficAllocationValid(valid);
        if (valid) {
          setFormData((prevData) => ({ ...prevData, abTestVariants: variants }));
        }
      }}
      viewMode={mode === 'view'}
    />
  );
};
